module.exports = __webpack_public_path__ + "static/media/kea-sports.3e2216e2.jpg";